window.Video = new function()
{
    this.vars = {
      token: jQuery('meta[name="csrf-token"]').attr('content')
    };

    this.init = function() {
        jQuery('video[data-compressed="0"]').each(function(index, el) {
            var video_id              = jQuery(el).data('id');
            var lastSecond            = null;
            var secondsToCallFunction = 5;
            var reloaded              = false;

            jQuery(el).on('timeupdate', function(e) {
                if(!reloaded) {
                    var seconds = Math.floor(e.target.currentTime);
                    if(seconds % secondsToCallFunction  == 0 && lastSecond !== seconds) {
                        lastSecond = seconds
                        Video.checkCompressed(video_id);
                        if(jQuery(el).attr('data-compressed') == 1) {
                            reloaded = true;
                            var time = e.target.currentTime;
                            el.load();
                            el.currentTime = time;
                            el.play();
                        }
                    }
                }
            });
        });
    };

    /**
     * Check to see if the video was compressed while a user was actively watching the uncompressed version
     *
     * @param int video_id
     */
    this.checkCompressed = function(video_id) {
        $.ajax({
            url: '/video/checkcompressed',
            type: 'POST',
            data: {
                video_id: video_id,
                _token: Video.vars.token
            },
            showloader: true,
            success: function(response) {
                if(response == 1) {
                    jQuery('video[data-id="'+video_id+'"]').attr('data-compressed', 1);
                }
            }
        });
    };
}

jQuery(document).ready(function($) {
    Video.init();
});
